export default function CommonProblems() {
  const problems = [
    { icon: 'ri-close-circle-line', text: 'Сотрудники не выполняют задачи в срок — сроки срываются, проекты затягиваются, клиенты недовольны.' },
    { icon: 'ri-close-circle-line', text: 'Приходится всё контролировать лично — руководитель становится бутылочным горлышком, без него ничего не работает.' },
    { icon: 'ri-close-circle-line', text: 'Команда сопротивляется изменениям — любые нововведения встречают саботаж, пассивную агрессию или открытые протесты.' },
    { icon: 'ri-close-circle-line', text: 'Сильные сотрудники увольняются — лучшие люди уходят к конкурентам, остаются те, кому всё равно.' },
    { icon: 'ri-close-circle-line', text: 'Руководители перегружены — работают по 12 часов, горят, не успевают думать о стратегии.' },
    { icon: 'ri-close-circle-line', text: 'Все вопросы идут к собственнику — владелец остаётся главным операционистом, хотя должен заниматься развитием.' },
    { icon: 'ri-close-circle-line', text: 'Между отделами конфликты — продажи винят производство, маркетинг винит продажи, каждый тянет одеяло на себя.' },
    { icon: 'ri-close-circle-line', text: 'Решения принимаются бесконечно долго — согласования длятся неделями, конкуренты действуют быстрее.' },
  ];

  const scrollTo = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Частые проблемы руководителей
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Если вы узнали хотя бы три пункта — пора системно заниматься обучением руководителей
        </p>

        <div className="max-w-4xl mx-auto space-y-3">
          {problems.map((item, i) => (
            <div key={i} className="flex items-start gap-4 bg-gray-50 p-5 rounded-xl hover:bg-teal-50 transition-colors group">
              <div className="w-9 h-9 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-lg text-red-500`}></i>
              </div>
              <span className="text-gray-800 text-sm md:text-base leading-relaxed pt-1">{item.text}</span>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-900 font-bold text-lg mb-6">
            Если эти проблемы знакомы — пора обучать руководителей
          </p>
          <button
            onClick={scrollTo}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Получить программу обучения
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}